import { Link } from "@tanstack/react-router";
import { cta } from "@/lib/analytics";
import { SectionMark } from "@/components/section-mark";

const contactNotes = [
  "Nie musisz wiedzieć, od czego zacząć.",
  "Rozmowa nie zobowiązuje do dalszej współpracy.",
];

export function ContactSection() {
  return (
    <section id="kontakt" className="content-visibility-auto scroll-mt-24 border-b border-ink/10 bg-surface">
      <div className="container-page section-pad">
        <div className="grid gap-8 md:grid-cols-[0.42fr_1fr] md:gap-12">
          <div>
            <SectionMark number="14" label="Kontakt" />

            <h2 className="display-xl mt-8 text-[1.9rem] md:text-[2.4rem]">Napisz do mnie</h2>
          </div>
          <div className="max-w-2xl">
            <div className="h-px w-full bg-steel" />
            <p className="lead-serif measure-text mt-8 max-w-xl">
              Wszystko, co napiszesz, traktuję poufnie.
            </p>
            <ul className="mt-6 space-y-2 text-sm leading-relaxed text-ink-soft">
              {contactNotes.map((item) => (
                <li key={item} className="flex gap-3">
                  <span aria-hidden="true" className="text-coral-text">
                    ·
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/kontakt"
                {...cta("kontakt-napisz-do-mnie", "kontakt", "inne")}
                className="btn-base btn-primary inline-flex min-h-11 items-center justify-center"
              >
                Napisz do mnie
              </Link>
              <Link
                to="/rezerwacja"
                {...cta("kontakt-rezerwacja", "kontakt", "konsultacja")}
                className="btn-base btn-outline inline-flex min-h-11 items-center justify-center"
              >
                Zarezerwuj pierwsze spotkanie
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
